import { render, staticRenderFns } from "./EditorResume.vue?vue&type=template&id=b4dda7e6&scoped=true"
import script from "./EditorResume.vue?vue&type=script&lang=js"
export * from "./EditorResume.vue?vue&type=script&lang=js"
import style0 from "./EditorResume.vue?vue&type=style&index=0&id=b4dda7e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dda7e6",
  null
  
)

export default component.exports